export default [
    {
        path: "/",
        name: "Index",
        component: resolve => require(["./Index.vue"], resolve)
    }
];



// WEBPACK FOOTER //
// ./src/views/home/router.js